import React, { Component } from 'react';
import TableView from './TableView';
import Percent from './Percent';
import { observer } from 'mobx-react';
import realnameStore from '../../Realname/request/model';
import { getRealname, getPersons } from '../../Realname/request/dao';
import './index.styl';

const clzpre = 'dsh-realname';

@observer
class Realname extends Component {
    constructor(props) {
        super(props);
        getPersons();
        getRealname();

        this.intervalData = undefined;
    }

    componentDidMount() {
        this.intervalData = setInterval(getRealname, 1000 * 20);
    }

    componentWillUnmount() {
        clearInterval(this.intervalData);
    }

    render() {
        const { realnames, userStatus } = this.props.realnameStore;
        return (
            <div className={`${clzpre} dsh-box`}>
                <h3>实名制界面</h3>
                <section>
                    <TableView data={realnames} />
                    <Percent data={userStatus} />
                </section>
            </div>
        );
    }
}

export default props => <Realname {...props} realnameStore={realnameStore} />;
